import SewaClientList from '../components/List/SewaClient'
import AirClientList from '../components/List/AirClinetList';
import { useAuth } from '../Auths/CheckUser';


const ClientList = () =>{

  const {user} = useAuth();

  return(
    <div className='mt-5'>
    

      { user.type === 'sewa' && <SewaClientList/>}
      { user.type === 'air' && <AirClientList/>}

    </div>
  );
}
export default ClientList;